import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"

// Updates the action bar's estimate while the Owner changes a step's answers.
// It POSTs the unsaved step form to the preview endpoint, which saves nothing
// and answers with a Turbo Stream replacing only the estimate.
export default class extends Controller {
  static values = { url: String }

  disconnect() {
    clearTimeout(this.timeout)
    this.abortController?.abort()
  }

  refresh() {
    clearTimeout(this.timeout)
    this.timeout = setTimeout(() => this.request(), 250)
  }

  async request() {
    this.abortController?.abort()
    this.abortController = new AbortController()

    const body = new FormData(this.element)
    body.delete("_method")

    try {
      const response = await fetch(this.urlValue, {
        method: "POST",
        headers: {
          Accept: "text/vnd.turbo-stream.html",
          "X-CSRF-Token": this.csrfToken()
        },
        body,
        signal: this.abortController.signal
      })
      if (!response.ok) return

      Turbo.renderStreamMessage(await response.text())
    } catch (error) {
      // A newer change replaced this request, or the network dropped it: the
      // estimate stays as it was until the next change or the step is saved.
      if (error.name !== "AbortError") console.warn("Estimate preview failed", error)
    }
  }

  csrfToken() {
    return document.querySelector('meta[name="csrf-token"]')?.getAttribute("content") || ""
  }
}
